import styled from 'styled-components';
import { colors } from '@/globalStyles';

export const ButtonsWrapper = styled.div`
  width: ${props => (props.width || '100%')};
  height: ${props => (props.height || '100%')};
  display: grid;
  grid-template-columns: ${props => props.gridTemplateColumns || 'repeat(3, 1fr)'};
  background-color: ${props => props.backgroundColor || colors.backgroundInput};
  align-items: ${props => (props.alignItems || 'center')};
  justify-content: ${props => props.justifyContent || 'center'};
`;

export const Button = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: IBMPlexSans;
  font-weight: ${props => props.selected && !props.skipBoldOnSelect ? 500 : 400};
  color: ${props => props.selected ? colors.primary : '#a6a6a6'};
  border-color: ${props => props.selected ? colors.primary : colors.black};
  border-bottom: ${props => props.selected ? ('2px solid ' + colors.primary) : (props.defaultBorderBottom || '2px solid transparent')};
  cursor: pointer;
  :hover {
    color: ${colors.primary};
    * {
      fill: ${colors.primary};
    }
  };
`;
